import { ProjectOverviewList } from '@dreamstack/accentro-contentful/src/blocks/CustomBlocks/ProjectOverviewList'
import { MainLayout } from '@dreamstack/feature-components/src/layout/MainLayout'
import { projectsOtherLocaleUrls } from '@dreamstack/feature-components/src/projects/helper/useProjectBaseUrl'
import {
  OtherLocaleUrlsContextProvider,
  useLocale,
  useTranslation,
} from '@dreamstack/i18n'
import { DreamstackSeo } from '@dreamstack/seo'
import { trpc } from '@dreamstack/trpc/client'
import { getStaticPropsPlus } from '../../lib/getStaticPropsPlus'

export default function Projects() {
  const locale = useLocale()
  const { data: projects } = trpc.project.getProjectsForOverview.useQuery(
    {
      locale,
    },
    {
      trpc: { ssr: true },
      staleTime: Infinity,
    }
  )

  const t = useTranslation()
  return (
    <>
      <OtherLocaleUrlsContextProvider context={projectsOtherLocaleUrls}>
        <DreamstackSeo nofollow={false} noindex={false} />
        <MainLayout
          navbarProps={{ forceDarkTextColor: false }}
          hero={{
            size: 'medium',
            noMarginBottom: true,
            backgroundImage: {
              url: '/static/images/projects-hero.jpg',
              filename: 'projects-hero',
              height: 860,
              width: 1920,
              title: 'Berlin Fernsehturm',
              alt: 'Berliner Fernsehturm aus der Vogelperspektive',
              id: 0,
              updatedAt: '',
              createdAt: '',
            },
            title: t('accentro:projects.hero.title'),
          }}
          showContactFooter={true}
          showNewsletterFooter={true}
        >
          <ProjectOverviewList
            onlyShowCurrentProjects={true}
            projects={projects}
          />
        </MainLayout>
      </OtherLocaleUrlsContextProvider>
    </>
  )
}

export const getStaticProps = getStaticPropsPlus({})
